import { GetPaymentAggregateResponse } from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';
import { ProviderAccount, RequiredAction, Status } from '@wix/ambassador-cashier-settings-v2-provider-account/types';
import { WIX_PAYMENT_PROVIDER_ID } from '../config/consts';

export function isWixPaymentProviderSupported(paymentAggregators: GetPaymentAggregateResponse): boolean {
  const providers = paymentAggregators?.providers || [];

  return providers.some((provider) => provider.id === WIX_PAYMENT_PROVIDER_ID);
}

export function hasAcceptPaymentsSetupFromProviderAccounts(providerAccounts: ProviderAccount[] | undefined): boolean {
  return (providerAccounts ?? []).some(isProviderAccountConfiguredForAcceptPayments);
}

function isProviderAccountConfiguredForAcceptPayments(providerAccount: ProviderAccount | undefined): boolean {
  if (!providerAccount) {
    return false;
  }

  const hasConnectedAccount = Boolean(providerAccount.providerAccountId || providerAccount.id);
  if (!hasConnectedAccount) {
    return false;
  }

  if (providerAccount.payinsAllowed === false) {
    return false;
  }

  // A pending action (e.g. claiming the account to enable payouts) means setup isn't finished.
  if (providerAccount.requiredAction && providerAccount.requiredAction !== RequiredAction.NONE) {
    return false;
  }

  if (typeof providerAccount.payoutsAllowed === 'boolean') {
    return providerAccount.payoutsAllowed;
  }

  if (providerAccount.status) {
    return providerAccount.status === Status.OK;
  }

  return (providerAccount.paymentMethodTypeSetups?.length ?? 0) > 0;
}
